export const SUPER_ADMIN_EMAIL = 'support@shareitt.com';
export const INFO_EMAIL = 'info@shareitt.com';
